import React from "react";
import { useTranslation } from "react-i18next";

//Style
import "./InfoEnergySection.css";

const InfoEnergySection = ({ info }) => {
  const { t } = useTranslation();

  return (
    <section className="info-ene-section">
      <div className="logos-container">
        <img
          style={{ width: "auto", height: "2rem" }}
          className="logo"
          src="https://pagina-otacc.s3.us-east-1.amazonaws.com/pages/otacc-page/assets/icons/suntacc-logo.webp"
          alt=""
        />
        <img
          style={{ width: "auto", height: "2.5rem" }}
          className="logo"
          src="https://pagina-otacc.s3.us-east-1.amazonaws.com/pages/otacc-page/assets/icons/logo-otacc-alt.webp"
          alt=""
        />
        <img
          style={{ width: "auto", height: "2.5rem" }}
          className="logo"
          src="https://pagina-otacc.s3.us-east-1.amazonaws.com/pages/otacc-page/assets/icons/logo-otacc.webp"
          alt=""
        />
      </div>
      <div className="description-container">
        <p className="desc-txt" style={{ fontSize: "1.5rem", color: "black" }}>
          {t("energy_page.info_section.complement_text_1")}
        </p>
        <p className="desc-txt" style={{ fontSize: "1.5rem", color: "black" }}>
          {t("energy_page.info_section.complement_text_2")}
        </p>
      </div>
      <div
        className="title-container"
        style={{ justifyContent: "center", marginLeft: 0 }}
      >
        <span className="deco-title"></span>
        <h1 className="ene-title">{t("energy_page.info_section.title")}</h1>
        <img
          style={{ width: "1.5rem" }}
          className="title-icon"
          src="https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/icons/title-icon-3.webp"
          alt=""
        />
      </div>
      <div className="info-ene-supercontainer">
        <div className="info-ene-container">
          <div className="info-ene-txt-container">
            <p className="ene-subtitle">
              {t("energy_page.info_section.list_info.title_1")}
            </p>
            <ul>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_1.list_text_1"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_1.list_text_2"
                )}
              </li>

              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_1.list_text_3"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_1.list_text_4"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_1.list_text_5"
                )}
              </li>

              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_1.list_text_6"
                )}
              </li>

              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_1.list_text_7"
                )}
              </li>

              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_1.list_text_8"
                )}
              </li>
            </ul>
          </div>
          <div className="info-ene-txt-container">
            <p className="ene-subtitle">
              {t("energy_page.info_section.list_info.title_2")}
            </p>
            <ul>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_2.list_text_1"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_2.list_text_2"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_2.list_text_3"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_2.list_text_4"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_2.list_text_5"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_2.list_text_6"
                )}
              </li>
            </ul>
          </div>
          <div className="info-ene-txt-container">
            <p className="ene-subtitle">
              {" "}
              {t("energy_page.info_section.list_info.title_3")}
            </p>
            <ul>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_3.list_text_1"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_3.list_text_2"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_3.list_text_3"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_3.list_text_4"
                )}
              </li>
              <li>
                {t(
                  "energy_page.info_section.list_info.list_elms_3.list_text_5"
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="description-container">
        <h1
          className="desc-txt"
          style={{ fontSize: "2rem", textAlign: "center" }}
        >
          {t("energy_page.info_section.complement_text_3")}
        </h1>
        <p className="desc-txt" style={{ textAlign: "center" }}>
          {t("energy_page.info_section.complement_text_4")}
        </p>
      </div>
    </section>
  );
};

export default InfoEnergySection;
